import { styled } from '@atom-web/core'
import { AutoComplete } from '@atom-web/macros'
import { Column, Row, Text } from '@atom-web/micros'
const DepatureCityComponent = ({ cities, onpress, selectedCity }) => {
	const outSideIndiaText = 'I’m departing from Outside India'
	const alreadyBookedText = 'I have booked my flights already'
	const StyledWrapper = styled('div', {
		width: '100%',
		'& ul[data-open="true"]': {
			width: '290px',
			borderRadius: '8px',
			padding: '0',
			marginTop: '$3',
			maxHeight: '310px',
			backgroundColor: '$white',
		},
	})

	function DropItem({ itemRender }) {
		return (
			<Column
				css={{
					cursor: 'pointer',
					padding: '$4',
					backgroundColor: '$white',
					maxHeight: '320px',
					'@smMax': {
						padding: 0,
					},
				}}
			>
				{itemRender()}
			</Column>
		)
	}
	return (
		<>
			<Column
				css={{
					width: '90%',
				}}
			>
				<StyledWrapper>
					<AutoComplete
						inputId="departure_city"
						label="Departure city"
						itemSize={50}
						selectedItem={selectedCity}
						updateOptions={(options, query) => {
							return query
								? options?.filter(val =>
										val?.label?.toLowerCase().includes(query?.toLowerCase()),
								  )
								: options
						}}
						keyExtractor={index => `${index}`}
						renderItem={(item, isHighlighted, isSelected) => {
							return (
								<DropItem
									itemRender={() => {
										return (
											<Row
												justify={'between'}
												css={{
													borderBottom: 'solid 1px $grey01',
													paddingBottom: '$2',
												}}
											>
												<Text
													css={{
														display: 'inline',
														color: '$grey10',
														fontSize: '$2',
														userSelect: 'none',
														fontWeight: '$normal',
													}}
												>
													{item.label}
												</Text>
												<Text
													css={{
														color: '$grey08',
														userSelect: 'none',
														fontSize: '$2',
														fontWeight: '$normal',
													}}
												>
													{item.value}
												</Text>
											</Row>
										)
									}}
									isHighlighted={isHighlighted}
									isSelected={isSelected}
								/>
							)
						}}
						options={cities}
						itemToString={item => {
							return item ? item.label : ''
						}}
						onChange={select => {
							select ? onpress(select) : null
						}}
						listHeight={() => 300}
						listFooter={
							<Row
								css={{
									width: '100%',
									height: '50px',
									backgroundColor: '$white',
									position: 'absolute',
									bottom: 0,
									overflow: 'unset',
									boxShadow: 'rgb(48 80 89 / 30%) 0px -1px 10px',
								}}
							>
								<Column
									onClick={() => {
										onpress({ label: 'Outside India' })
									}}
									align={'center'}
									justify="center"
									css={{
										width: '50%',
										borderRight: 'solid 1px $grey02',
										userSelect: 'none',
										cursor: 'pointer',
										fontSize: '$1',
										color: '$grey10',
										fontWeight: '$normal',
										lineHeight: '$1',
										textAlign: 'center',
									}}
								>
									{outSideIndiaText}
								</Column>
								<Column
									onClick={() => {
										onpress({ label: 'Already Booked' })
									}}
									align={'center'}
									justify="center"
									css={{
										userSelect: 'none',
										cursor: 'pointer',
										width: '49%',
										fontSize: '$1',
										color: '$grey10',
										fontWeight: '$normal',
										lineHeight: '$1',
										textAlign: 'center',
									}}
								>
									{alreadyBookedText}
								</Column>
							</Row>
						}
					/>
				</StyledWrapper>
			</Column>
		</>
	)
}
export default DepatureCityComponent
